export const ADS_ENABLED = false;
export const ADSENSE_CLIENT = "ca-pub-8547286671324391";

let adSenseScriptPromise: Promise<void> | null = null;

export function loadAdSense(): Promise<void> {
  if (!ADS_ENABLED) return Promise.resolve();
  if (adSenseScriptPromise) return adSenseScriptPromise;

  window.adsbygoogle = window.adsbygoogle ?? [];
  adSenseScriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`;
    script.crossOrigin = "anonymous";
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("ADSENSE_PROVIDER_FAILED"));
    document.head.appendChild(script);
  });
  return adSenseScriptPromise;
}

declare global {
  interface Window {
    adsbygoogle?: Array<Record<string, never>>;
  }
}
